/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoSortMedia } from '../../models/dto-sort-media';
import { TravelDraftMinimal } from '../../models/travel-draft-minimal';

export interface TravelControllerSortPictures$Params {
  id: number;
      body: DtoSortMedia
}

export function travelControllerSortPictures(http: HttpClient, rootUrl: string, params: TravelControllerSortPictures$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftMinimal;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerSortPictures.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelDraftMinimal;
      }>;
    })
  );
}

travelControllerSortPictures.PATH = '/travel/{id}/picture/sort';
